/**
 * System/reduxStore.js — Central Redux store configuration.
 * Combines 12 slice reducers covering auth, project state, analysis results,
 * navigation, and UI data. DevTools are enabled for debugging.
 */
import { configureStore } from "@reduxjs/toolkit";

// ----------------- Reducers ----------------- //
import user from "Redux/user/reducer";
import conversions from "Redux/conversions/reducer";
import project from "Redux/project/reducer";
import invoice from "Redux/invoice/reducer";
import dashboard from "Redux/dashboard/reducer";
import performance from "Redux/performance/reducer";
import projects from "Redux/projects/reducer";
import files from "Redux/files/reducer";
import nav from "Redux/nav/reducer";
import data from "Redux/data/reducer";
import advance from "Redux/advance/reducer";
import criteria from "Redux/criteria/reducer";
import chats from "Redux/chats/reducer";
// ----------------- Store ----------------- //
const store = configureStore({
  reducer: {
    user,
    conversions,
    project,
    projects,
    invoice,
    dashboard,
    performance,
    advance,
    files,
    nav,
    data,
    criteria,
    chats,
  },
  devTools: true,
});
export default store;